// ./src/components/features/Forms/FormFieldsEditModal/UuidFieldOptionsEditor.tsx
import React from "react";
import { Stack, Switch, MultiSelect, Text } from "@mantine/core";
import { UuidFieldOptions } from "./fieldOptionsTypes";

export interface UuidFieldOptionsEditorProps {
  value: UuidFieldOptions;
  onChange: (options: UuidFieldOptions) => void;
}

const UUID_VERSION_OPTIONS = [
  { value: "1", label: "Version 1 (timestamp-based)" },
  { value: "2", label: "Version 2 (DCE security)" },
  { value: "3", label: "Version 3 (MD5 hash)" },
  { value: "4", label: "Version 4 (random)" },
  { value: "5", label: "Version 5 (SHA-1 hash)" },
];

export const UuidFieldOptionsEditor: React.FC<UuidFieldOptionsEditorProps> = ({
  value,
  onChange,
}) => {
  const handleChange = (field: keyof UuidFieldOptions, fieldValue: any) => {
    onChange({
      ...value,
      [field]: fieldValue,
    });
  };

  const handleVersionsChange = (versions: string[]) => {
    const numericVersions = versions.map((v) => parseInt(v, 10));
    onChange({
      ...value,
      allowedVersions: numericVersions.length > 0 ? numericVersions : undefined,
    });
  };

  return (
    <Stack gap="sm">
      <Text size="xs" c="dimmed">
        Validates standard UUID format (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx).
      </Text>

      <MultiSelect
        label="Allowed UUID versions"
        description="Leave empty to accept all versions"
        placeholder="All versions"
        data={UUID_VERSION_OPTIONS}
        value={(value.allowedVersions ?? []).map((v) => v.toString())}
        onChange={handleVersionsChange}
        clearable
        size="sm"
      />

      <Switch
        label="Allow nil UUID"
        description="Accept 00000000-0000-0000-0000-000000000000"
        checked={value.allowNil ?? false}
        onChange={(e) => handleChange("allowNil", e.currentTarget.checked)}
        size="sm"
      />
    </Stack>
  );
};
